import React from "react";
import { SkedCheckbox } from "ui";
import { Status } from "./edit-user";

type AllowPostStatusProps = {
  allowStatus: Status;
  handlePostStatusChange: (allowStatus: Status) => void;
  disabled?: boolean;
};

const AllowPostStatus = ({
  allowStatus,
  handlePostStatusChange,
  disabled,
}: AllowPostStatusProps): React.ReactElement => {
  const helperBits: string[] = [];
  if (allowStatus.isDefault) {
    helperBits.push("Default status");
  }
  if (allowStatus.isPublishingAllowed) {
    helperBits.push("posts publish when scheduled");
  }
  const helper = helperBits.length > 0 ? helperBits.join(" — ") : null;

  return (
    <div className="pb-3 last:pb-0" key={allowStatus.label}>
      <SkedCheckbox
        checked={allowStatus.selected}
        onClick={() => handlePostStatusChange(allowStatus)}
        disabled={disabled || allowStatus.isDefault}
        className="block leading-[1.4]"
      >
        {allowStatus.label}
      </SkedCheckbox>
      {helper && (
        <p
          data-testid={allowStatus.isDefault ? "defaultStatus" : "willPublish"}
          className="mt-0.5 ml-6 text-xs text-neutral-600"
        >
          {helper}
        </p>
      )}
    </div>
  );
};

const AllowPostStatusList = ({
  postStatusList,
  setPostStatusList,
  disabled = false,
}: {
  postStatusList: Status[];
  setPostStatusList: (status: Status[]) => void;
  disabled?: boolean;
}): React.ReactElement => {
  const handlePostStatusChange = (status: Status) => {
    if (disabled) return;
    setPostStatusList(
      postStatusList.map((item) => ({
        ...item,
        selected: item === status ? !status.selected : item.selected,
      }))
    );
  };

  return (
    <>
      {postStatusList.map((allowStatus) => (
        <AllowPostStatus
          key={allowStatus.label}
          allowStatus={allowStatus}
          handlePostStatusChange={handlePostStatusChange}
          disabled={disabled}
        />
      ))}
    </>
  );
};

export default AllowPostStatusList;
